import { render } from "./ProfileGetToken.vue?vue&type=template&id=acbe435a"
import script from "./ProfileGetToken.vue?vue&type=script&lang=js"
export * from "./ProfileGetToken.vue?vue&type=script&lang=js"

import "./ProfileGetToken.vue?vue&type=style&index=0&id=acbe435a&lang=css"

import exportComponent from "/home/runner/work/pescle-rodent/pescle-rodent/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__